import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function PrivateRoute({ children, adminOnly = false }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center text-gray-600">جاري التحميل...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.requires_auction_selection) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && !['super_admin', 'admin'].includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
